import { useLocation } from 'react-router-dom'

export default function FooterContent(props) {

    const location = useLocation();
    const year = new Date().getFullYear();//获取当前年份

    return (
        <div style={{
            textAlign: "center",
            height: "60px",
            backgroundColor: "#424242",
            color: "#fff",
            display: location.pathname == "/" ? "none" : "flex",
            alignItems: "center",
            justifyContent: "center"
        }} >
            GEO-Curator © {year} The Ren Lab. All Rights Reserved
        </div>
    )
}